<template>
  <span
    class="risk-badge"
    :class="sizeClass"
    :style="{
      '--fg': tone.fg,
      '--bg': tone.bg
    }"
  >
    <slot>{{ labelFromLevel }}</slot>
  </span>
</template>

<script>
export default {
  name: 'CustomBadge',
  props: {
    /** 'low' | 'medium' | 'high' | 'very-high' */
    level: { type: String, default: 'low' },
    /** 텍스트를 직접 지정하고 싶을 때 */
    label: { type: String, default: '' },
    /** 'sm' | 'md' | 'lg' */
    size:  { type: String, default: 'md' }
  },
  computed: {
    map() {
      return {
        'low':       { fg: '#16a34a', bg: 'rgba(22,163,74,.12)' },   // 초록
        'medium':    { fg: '#d97706', bg: 'rgba(217,119,6,.14)' },   // 주황
        'high':      { fg: '#ef4444', bg: 'rgba(239,68,68,.14)' },   // 빨강
        'very-high': { fg: '#2563eb', bg: 'rgba(37,99,235,.14)' }    // 파랑
      }
    },
    tone() {
      return this.map[this.level] || this.map['low']
    },
    labelFromLevel() {
      if (this.label) return this.label
      if (this.level === 'very-high') return 'Very High'
      return this.level.charAt(0).toUpperCase() + this.level.slice(1)
    },
    sizeClass() {
      return {
        'risk-badge--sm': this.size === 'sm',
        'risk-badge--md': this.size === 'md',
        'risk-badge--lg': this.size === 'lg'
      }
    }
  }
}
</script>

<style scoped>
.risk-badge {
  min-width: 60px;
  display:inline-flex; align-items:center; justify-content:center;
  padding: .36rem .8rem;
  border-radius: 9999px;
  font-weight: 600;
  line-height: 1;
  letter-spacing: .2px;
  color: var(--fg);
  background: var(--bg);
  user-select:none;
  white-space:nowrap;
  box-shadow: 0 0 0 1px rgba(0,0,0,.03) inset;
}
.risk-badge--sm { font-size: .8rem;  padding: .28rem .6rem; }
.risk-badge--md { font-size: .875rem; }
.risk-badge--lg { font-size: 1rem;    padding: .48rem 1rem; }
</style>